<template>
  <div class="row">
    <div class="col-12 mb-2">
      <b-card header="Sage TAX Customer Export - Employee Details" header-tag="h4" class="bg-default-card">
        <div class="row">
          <div class="col-6 offset-6" v-if="tax_export_rows !== null && tax_export_rows.length > 0">
            <button class="btn orcaBtn w-100 sm_btn" @click.prevent="tax_export_workers" :disabled="exporting">
              <span v-if="!exporting"><i class="fa fa-download"></i>&nbsp; Tax Worker Export (CSV)</span>
              <span v-if="exporting"><i class="fas fa-spinner fa-pulse"></i>&nbsp; Exporting ...</span>
            </button>
          </div>
          <div class="col-12 mt-4">
            <datatable :type="''" :recordType="''" :rowData="tax_export_rows" :loadingMessage="loadingMessage"
                       :noRowsMessage="noRowsMessage" :columns="columns" :heightStyle="heightStyle"></datatable>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import datatable from "datatables/export_datatable";

export default {
  name: "tax_workers_export",
  components: {
    datatable,
    'delete_row': {
      name: 'delete_row',
      template: '<div>' +
          '<button class="btn orcaBtn sm_btn danger" @click.prevent="remove(params.data.id)"><i class="fas fa-trash-alt"></i></button>' +
          '</div>',
      methods: {
        remove(id) {
          axios.delete(this.crmApiPath + 'finance/export/worker/tax/destroy/' + id).then(() => {
            this.$bus.$emit('worker:sage:export');
            this.$nextTick(() => this.$parent.$parent.$parent.refreshSTtable = 1)
          })
        },
      }
    }
  },
  data() {
    return {
      heightStyle: 'height: 400px !important',
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Queued for Export',
      tax_export_rows: null,

      refreshSTtable: 0,
      columns: [
        {headerName: '', minWidth: 65, field: 'id', cellRendererFramework: 'delete_row', filter: false, sort: false},
        {headerName: 'Account Number', field: 'account_number', minWidth: 105, suppressSizeToFit: true},
        {headerName: 'Worker Name', field: 'worker_name', minWidth: 200, suppressSizeToFit: true},
        {headerName: 'Account Name', field: 'account_name', minWidth: 200, suppressSizeToFit: true},
        {headerName: 'Street 1', field: 'address_1', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Street 2', field: 'address_2', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Town', field: 'address_3', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'County', field: 'address_4', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Postcode', field: 'post_code', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'Contact Name', field: 'account_number', minWidth: 105, suppressSizeToFit: true},
        {headerName: 'Telephone Number', field: 'mobile_number', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Email Address', field: 'email_address', minWidth: 225, suppressSizeToFit: true},
      ],
      exporting: false
    }
  },
  mounted() {
    this.get_data();
  },
  methods: {
    get_data() {
      axios.get(this.crmApiPath + 'finance/export/worker/tax').then(res => {
        this.tax_export_rows = [];
        for (let i = 0; i < res.data.length; i++) {
          // Declare Variables
          let accounts_number = '', account_name = '', worker_name = '', address_1 = '', address_2 = '', address_3 = '', address_4 = '',
              post_code = '', telephone_number = '', mobile_number = '', email_address = '', nominal_account = '',
              sort_code = '', bank_account_number = '', bank_account_name = '', payment_ref = '', analysis_1 = '';

          // if limited company and has company_internal_finance_ref use this number -> else use worker internal_finance_ref
          if (res.data[i].worker.rel_company_info.employment_type_id === 32 && res.data[i].worker.rel_company_info.company_internal_finance_ref !== null) {
            accounts_number = res.data[i].worker.rel_company_info.company_internal_finance_ref;
          }
          else {
            accounts_number = res.data[i].worker.internal_finance_ref;
          }
          // Worker Name
          let w_first = '', w_second = '';
          if (res.data[i].worker.person.first_name !== null && res.data[i].worker.person.first_name !== '') {
            w_first = res.data[i].worker.person.first_name
          }
          if (res.data[i].worker.person.surname !== null && res.data[i].worker.person.surname !== '') {
            w_second = res.data[i].worker.person.surname
          }
          worker_name = w_first + ' ' + w_second
          // Account Name = First Name + Surname OR Trading Name
          // PAYE -> Else not PAYE
          let first = '', second = '';
          if (res.data[i].worker.rel_company_info.employment_type === 33) {
            if (res.data[i].worker.person.first_name !== null && res.data[i].worker.person.first_name !== '') {
              first = res.data[i].worker.person.first_name
            }
            if (res.data[i].worker.person.surname !== null && res.data[i].worker.person.surname !== '') {
              second = res.data[i].worker.person.surname
            }
            account_name = first + ' ' + second;
          }
          else {
            if (res.data[i].worker.rel_company_info.company_trading_name !== null && res.data[i].worker.rel_company_info.company_trading_name !== '') {
              account_name = res.data[i].worker.rel_company_info.company_trading_name
            }
            else {
              if (res.data[i].worker.person.first_name !== null && res.data[i].worker.person.first_name !== '') {
                first = res.data[i].worker.person.first_name
              }
              if (res.data[i].worker.person.surname !== null && res.data[i].worker.person.surname !== '') {
                second = res.data[i].worker.person.surname
              }
              account_name = first + ' ' + second;
            }
          }
          // address get (check for company address first [and if different from personal address])
          if (res.data[i].worker.rel_addresses.find(a => a.address_type_id === 106) !== undefined && !res.data[i].worker.rel_company_info.company_address_same_as_personal) {
            let temp = res.data[i].worker.rel_addresses.find(a => a.address_type_id === 106);
            if (temp.building !== null && temp.building !== '') {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.building + ', ' + temp.street
              }
              else {
                address_1 = temp.building
              }
            }
            else {
              address_1 = ''
            }
            address_2 = temp.locality !== null && temp.locality !== '' ? temp.locality : '';
            address_3 = temp.city_town !== null && temp.city !== '' ? temp.city_town : '';
            address_4 = temp.county !== null && temp.county !== '' ? temp.county : '';
            post_code = temp.postcode !== null && temp.postcode !== '' ? temp.postcode : '';
          }
          // else use personal address
          else if (res.data[i].worker.rel_addresses.find(a => a.address_type_id === 47) !== undefined) {
            let temp = res.data[i].worker.rel_addresses.find(a => a.address_type_id === 47);
            if (temp.building !== null && temp.building !== '') {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.building + ', ' + temp.street
              }
              else {
                address_1 = temp.building
              }
            }
            else {
              address_1 = ''
            }
            address_2 = temp.locality !== null && temp.locality !== '' ? temp.locality : '';
            address_3 = temp.city_town !== null && temp.city !== '' ? temp.city_town : '';
            address_4 = temp.county !== null && temp.county !== '' ? temp.county : '';
            post_code = temp.postcode !== null && temp.postcode !== '' ? temp.postcode : '';
          }
          // Telephone Phone get
          telephone_number = res.data[i].worker.rel_phones.find(e => e.phone_type_id === 58) !== undefined ? res.data[i].worker.rel_phones.find(e => e.phone_type_id === 58).phone_number : '';
          // Mobile Number
          mobile_number = res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59) !== undefined
              ? res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59).phone_number : '';
          // Email get
          email_address = res.data[i].worker.rel_emails.find(e => e.email_type_id === 67) !== undefined ?
              res.data[i].worker.rel_emails.find(e => e.email_type_id === 67).email_address : '';
          // Nominal Account
          if (this.crmType === 'payroll') {
            nominal_account = 6000
          }
          if (this.crmType === 'recruitment') {
            nominal_account = '?'
          }
          // if company bank details exist use these (they may be the same as personal) else use personal bank details
          if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40) !== undefined && !res.data[i].worker.rel_company_info.company_bank_same_as_personal) {
            sort_code = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code : '';
            bank_account_number = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).account_number !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).account_number : '';
            bank_account_name = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).accounts_holder !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).accounts_holder : '';
          }
          else if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39) !== undefined) {
            sort_code = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code : '';
            bank_account_number = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).account_number !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).account_number : '';
            bank_account_name = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).accounts_holder !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).accounts_holder : '';
          }
          // Payment Reference
          if (this.crmType === 'payroll') {
            payment_ref = 'Genius Money'
          }
          if (this.crmType === 'recruitment') {
            payment_ref = 'V3 Recruitment'
          }
          // Analysis Code 1 -- Currently assigned company
          analysis_1 = res.data[i].assignment !== null ? res.data[i].assignment.company.company_name : '';
          // push to list -> export table and accounts export file data
          this.tax_export_rows.push({
            'id': res.data[i].id,
            'account_number': accounts_number,
            'worker_name': worker_name,
            'account_name': account_name,
            'address_1': address_1,
            'address_2': address_2,
            'address_3': address_3,
            'address_4': address_4,
            'post_code': post_code,
            'telephone_number': telephone_number,
            'mobile_number': mobile_number,
            'email_address': email_address,
            'nominal_account': nominal_account,
            'sort_code': sort_code,
            'bank_account_number': bank_account_name,
            'bank_account_name': bank_account_number,
            'payment_ref': payment_ref,
            'analysis_1': analysis_1,
          })
        }
      })
    },
    tax_export_workers() {
      this.exporting = true;
      axios.post(this.crmApiPath + 'finance/export/worker/tax/export', this.tax_export_rows, {
        responseType: 'arraybuffer'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Tax_workers_export_' + this.$moment.utc().format('DD-MM-YYYY-hh-mm') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        axios.post(this.crmApiPath + 'finance/export/worker/tax/exported').then(() => {
          this.$bus.$emit('worker:sage:export');
          this.refreshSTtable = 1;
          this.exporting = false;
        });
      });
    }
  },
  watch: {
    refreshSTtable(val) {
      if (val === 1) {
        this.tax_export_rows = [];
        this.get_data();
        this.refreshSTtable = 0;
      }
    }
  },
}
</script>
